// extracted by mini-css-extract-plugin
export default {"container":"slider-placeholder_container__R6xJ6","image":"slider-placeholder_image__PJfIe","bottom":"slider-placeholder_bottom__Tt5I5"};